import React from 'react';
import { Card } from '../ui/card';
import { Loader2, TrendingUp } from 'lucide-react';

/* Homepage visitor stats — daily buckets, CSS bar chart */
export const AdminTrafficTab = ({ traffic, loading }) => {
  if (loading || !traffic) {
    return (
      <div className="flex justify-center py-20">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  const counts = Object.fromEntries((traffic.daily || []).map((d) => [d.date, d.count]));
  const daily = Array.from({ length: 30 }, (_, i) => {
    const dt = new Date(Date.now() - (29 - i) * 86400000);
    const date = dt.toISOString().slice(0, 10);
    return { date, count: counts[date] || 0 };
  });
  const hasData = daily.some((d) => d.count > 0);
  const max = Math.max(1, ...daily.map((d) => d.count));
  const stats = [
    { label: 'Today', value: traffic.today },
    { label: 'Last 7 days', value: traffic.last7 },
    { label: 'Last 30 days', value: traffic.last30 },
    { label: 'All time', value: traffic.total },
  ];

  return (
    <div className="space-y-6" data-testid="admin-traffic-tab">
      <div className="flex items-center gap-2">
        <TrendingUp className="w-5 h-5 text-primary" />
        <h2 className="text-lg font-semibold">Homepage visitors</h2>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {stats.map((s) => (
          <Card key={s.label} className="p-5" data-testid={`traffic-stat-${s.label.toLowerCase().replace(/\s/g, '-')}`}>
            <p className="text-xs text-muted-foreground uppercase tracking-wider mb-1">{s.label}</p>
            <p className="text-3xl font-bold tabular-nums">{s.value.toLocaleString()}</p>
          </Card>
        ))}
      </div>

      <Card className="p-6" data-testid="traffic-chart">
        <p className="text-sm font-semibold mb-1">Visits per day — last 30 days</p>
        <p className="text-xs text-muted-foreground mb-5">
          Counted once per browser session on the landing page. Bots and crawlers are filtered out.
        </p>
        {!hasData ? (
          <p className="text-sm text-muted-foreground py-8 text-center">
            No visits recorded yet — data starts collecting from now.
          </p>
        ) : (
          <div className="flex items-end gap-[3px] h-40">
            {daily.map((d) => (
              <div key={d.date} className="flex-1 group relative flex flex-col justify-end h-full">
                <div
                  className="rounded-t-sm bg-primary/70 group-hover:bg-primary transition-colors min-h-[3px]"
                  style={{ height: `${(d.count / max) * 100}%` }}
                />
                <div className="absolute -top-9 left-1/2 -translate-x-1/2 hidden group-hover:block bg-foreground text-background text-[10px] px-2 py-1 rounded whitespace-nowrap z-10">
                  {d.date} · {d.count}
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
};
